import { useState as a } from "react";
const l = (c, t, e) => Math.min(Math.max(c, t), e);
function f(c, t, e, r, s) {
  const [n, m] = a(l(c, t, e)), u = (o) => {
    const i = n + o;
    m(i), s == null || s(i);
  };
  return {
    value: n,
    increment: () => u(1),
    decrement: () => u(-1),
    incrementIsDisabled: n >= e || r,
    decrementIsDisabled: n <= t || r
  };
}
export {
  f as useCounter
};
